import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const DEVICE_ID_KEY = 'deviceId';

let memoryDeviceId = null;
let fingerprint = null;
let fingerprintPromise = null;

const randomByte = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return crypto.getRandomValues(new Uint8Array(1))[0];
  }
  return Math.floor(Math.random() * 256);
};

const generateUuid = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (randomByte() & (15 >> (c / 4)))).toString(16)
  );
};

// Stable per-browser id. localStorage can be blocked (private mode), so fall
// back to an id kept in memory for the lifetime of the page.
export const getDeviceId = () => {
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY);
    if (stored) return stored;
  } catch (e) {
    // fall through to the in-memory id
  }
  if (!memoryDeviceId) {
    memoryDeviceId = generateUuid();
    try {
      localStorage.setItem(DEVICE_ID_KEY, memoryDeviceId);
    } catch (e) {
      // keep the in-memory id only
    }
  }
  return memoryDeviceId;
};

export const peekFingerprint = () => fingerprint;

export const loadFingerprint = () => {
  if (!fingerprintPromise) {
    fingerprintPromise = FingerprintJS.load({ monitoring: false })
      .then((fp) => fp.get())
      .then((result) => {
        fingerprint = result.visitorId;
        return fingerprint;
      })
      .catch(() => null);
  }
  return fingerprintPromise;
};

loadFingerprint();
